import { useState, useEffect } from 'react';

type StorageType = 'localStorage' | 'sessionStorage';

interface UseLocalDataProps<T> {
  storageType: StorageType;
  key: string;
  initialValue: T;
}

export function useLocalData<T>({ storageType, key, initialValue }: UseLocalDataProps<T>) {
    const storage = storageType === 'localStorage' ? localStorage : sessionStorage;

    const clear = () => {
        storage.removeItem(key);
    };

    const getStoredValue = (): T => {
        try {
            const item = storage.getItem(key);

            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error('Error reading from storage', error);

            return initialValue;
        }
    };

    const [value, setValue] = useState<T>(getStoredValue);

    useEffect(() => {
        try {
            storage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error('Error saving to storage', error);
        }
    }, [key, value, storage]);

    return [value, setValue, clear] as const;
}
